import { AxiosError, AxiosResponse } from 'axios'
import { ErrorCode } from '../types/API'
import { alertError } from '../components/Notifications'

export const getErrorMessage = (error: unknown): string => {
  if (!error) return 'No response from server'

  if (error instanceof AxiosError) {
    const { response } = error

    if (!response) return 'An unknown error occurred'

    const { status, data } = response

    // CodeIgniter HTML error - get from page title and first paragraph
    if (typeof data === 'string' && data.startsWith('<!DOCTYPE')) {
      const titleError = data.substring(
        data.indexOf('<title>') + 7,
        data.lastIndexOf('</title>'),
      )
      const startOfFirstParagraph = response.data.split('<p>')[1]
      if (!startOfFirstParagraph) return titleError

      const paragraphError = startOfFirstParagraph.substring(
        0,
        startOfFirstParagraph.indexOf('</p>'),
      )
      return `${titleError}: ${paragraphError}`
    }

    // still need this for Trust Payments card errors
    // @ts-ignore should be no `data.error`. When error, message should return in `data`.
    const badError = data && data.error
    if (badError) return `Error: ${badError}`

    // regular error
    if (data) return `Error: ${data}`

    // if we have no custom message, infer from codes
    const { Forbidden, Unauthorized, NotFound } = ErrorCode
    if (status === Forbidden || status === Unauthorized) {
      return 'Access forbidden'
    }
    if (status === NotFound) return 'Server route not found'
  }

  return 'Unknown server response'
}

export enum Path {
  Logout = '/logout',
}
export enum Status {
  OK = 200,
  Created = 201,
}
export const api = async <T extends AxiosResponse>(
  request: Promise<T>,
  expected: Status,
  silent?: true,
): Promise<AxiosResponse['data'] | false> => {
  try {
    const res = await request

    const { status, data } = res
    if (res && status === expected) return data

    return false
  } catch (error) {
    if (error instanceof AxiosError) {
      const { response } = error
      const { status } = response || {}

      if (status === ErrorCode.Forbidden || status === ErrorCode.Unauthorized) {
        window.location.href = Path.Logout
      }
    }

    if (!silent) alertError(getErrorMessage(error))
    return false
  }
}
